import { Navigate } from 'react-router';

import Dashboard from './Dashboard';
import MyAccount from './MyAccount';
import UserResourcePage from './UserResourcePage';
import UserResourceIndex from './UserResourceIndex';

const userRoutes = [
  {
    index: true,
    element: <Navigate to="/" />
  },
  {
    path: 'account',
    element: <MyAccount />
  },
  {
    path: 'dashboard',
    element: <Dashboard />,
    children:[
      {index:true, element:<UserResourceIndex/>},
      {
        path: 'r/:userResource/',
        element: <UserResourcePage />
      }
    ]
  },
  
];

export default userRoutes;
